import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-loading-spinner-fuse',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './loading-spinner-fuse.component.html',
  styleUrls: ['./loading-spinner-fuse.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerFuseComponent {
  @Input() diameter: number = 30;
  @Input() centered: boolean = true;
  @Input() message: string = '';
}
